// @flow strict

import React, { type Node } from 'react';
import { Button as MaterialButton } from '@material-ui/core';

import * as styles from './button.module.less';

/**
 * Type of component properties
 */
type ButtonProps = {
  link: string,
  title: string,
  children: Node,
  cta: boolean,
};

/**
 * Render button with link for passed URL.
 *
 * @param {ButtonProps} props - Component properties
 *
 * @returns {Node}
 */
export const Button = ({ link, title, children, cta }: ButtonProps) => {
  return (
    <div className={styles.buttonWrapper}>
      <a
        href={link}
        title={title}
        rel="noreferrer noopener"
        className={cta ? 'cta-button' : ''}
      >
        <MaterialButton
          variant="contained"
          color="primary"
          size="large"
          classes={{ root: styles.buttonRoot }}
        >
          {children}
        </MaterialButton>
      </a>
    </div>
  );
};
